import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {useGeolocation} from 'presentation/hooks/useGeolocation';
import {usePermissions} from 'presentation/hooks/usePermissions';

export const useHomeGeolocationPrompt = () => {
	const {state} = useLocation();
	const {permission, checkPermission} = usePermissions({permissionName: 'geolocation'});
	const {getPosition} = useGeolocation();
	const hasTriggeredRef = useRef(false);

	useEffect(() => {
		checkPermission();
	}, []);

	useEffect(() => {
		const isCommingFromEntryFlow = (state as {isCommingFromEntryFlow?: boolean})
			?.isCommingFromEntryFlow;

		if (!hasTriggeredRef.current && isCommingFromEntryFlow && permission === 'prompt') {
			hasTriggeredRef.current = true;
			getPosition();
		}
	}, [permission, state, getPosition]);
};
